const GATEWAY_STATES_UPDATED = (state, gateway_states) => {
  state.gateway_states = gateway_states
}

const GATEWAY_STATE_UPDATED = (state, gateway_state) => {
  state.gateway_state = gateway_state
}

const GATEWAY_LIST_VIEW_UPDATED = (state, gateway_list_view) => {
  state.gateway_list_view = gateway_list_view
}

const GATEWAY_REVISIONS_UPDATED = (state, gateway_revisions) => {
  state.gateway_revisions = gateway_revisions
}

const GATEWAY_REVISIONS_VIEW_UPDATED = (state, gateway_revisions_view) => {
  state.gateway_revisions_view = gateway_revisions_view
}

const NETWORK_PROFILE_REVISIONS_UPDATED = (state, profile_revisions) => {
  state.profile_revisions = profile_revisions
}

const NETWORK_PROFILE_REVISIONS_VIEW_UPDATED = (state, profile_revisions_view) => {
  state.profile_revisions_view = profile_revisions_view
}

const SPECTRAL_SCAN_UPDATED = (state, spectral_scan) => {
  state.spectral_scan = spectral_scan
}

const SPECTRAL_SCAN_VIEW_UPDATED = (state, spectral_scan_view) => {
  state.spectral_scan_view = spectral_scan_view
}

export default {
  GATEWAY_STATES_UPDATED,
  GATEWAY_STATE_UPDATED,
  GATEWAY_LIST_VIEW_UPDATED,
  GATEWAY_REVISIONS_UPDATED,
  GATEWAY_REVISIONS_VIEW_UPDATED,
  NETWORK_PROFILE_REVISIONS_UPDATED,
  NETWORK_PROFILE_REVISIONS_VIEW_UPDATED,
  SPECTRAL_SCAN_UPDATED,
  SPECTRAL_SCAN_VIEW_UPDATED
}



// WEBPACK FOOTER //
// ./src/modules/gatewayStates/store/mutations.js